import React, { useEffect, useState } from "react";
import { PLUGINS_KEYS } from "@/other/constants/PluginKeys";
import { TIMELINE_CONG_KEYS } from "@/other/constants/OtherKeys";
import { getScheduleInstanceFromViewManager } from "@/other/utils/otherUtils";
import { Checkbox } from "@/modern/components/ui/checkbox";
import { Label } from "@/modern/components/ui/label";
import { useSwivuBryntumContext } from "@/react/hooks/useSwivuBryntumContext";
import { Card } from "@/modern/components/ui/card";

export const SettingsTab = () => {
  const context = useSwivuBryntumContext();
  const viewManager = context.viewManager;
  const [stripeNonWorkingDays, setStripeNonWorkingDays] = useState(false);
  const [hideNonWorkingDays, setHideNonWorkingDays] = useState(false);
  const [skipNonWorkingDayDuringReplicating, setSkipNonWorkingDayDuringReplicating] = useState(false);

  const schedulerView = getScheduleInstanceFromViewManager(viewManager);

  useEffect(() => {
    if (schedulerView) {
      const selectedState = schedulerView.features[PLUGINS_KEYS.swivuTimelineConfigurator]?.state;

      if (selectedState) {
        setStripeNonWorkingDays(selectedState[TIMELINE_CONG_KEYS.stripeNonWorkingDays] || false);
        setHideNonWorkingDays(selectedState[TIMELINE_CONG_KEYS.hideNonWorkingDays] || false);
        setSkipNonWorkingDayDuringReplicating(selectedState[TIMELINE_CONG_KEYS.skipNonWorkingDayDuringReplicating] || false);
      }
    }
  }, [schedulerView]);

  const handleSettingChange = (key: string, value: boolean) => {
    if (schedulerView) {
      schedulerView.features[PLUGINS_KEYS.swivuTimelineConfigurator]?.swivuExecuteSettings(key, value);
    }
  };

  return (
    <Card className="py-3 px-4">
      <div className="space-y-6">
        <div>
          <h3 className="text-base font-semibold text-foreground mb-1">Non-Working Time Display</h3>
          <p className="text-xs text-muted-foreground">Column placement and management</p>
        </div>
        <div className="space-y-4">
          {/* Stripe Checkbox */}
          <div className="flex items-start space-x-3">
            <Checkbox
              id="stripeNonWorkingDays"
              checked={stripeNonWorkingDays}
              onCheckedChange={(checked) => {
                setStripeNonWorkingDays(checked as boolean);
                handleSettingChange(TIMELINE_CONG_KEYS.stripeNonWorkingDays, checked as boolean);
              }}
              className="mt-0.5"
            />
            <div className="space-y-1 leading-none">
              <Label htmlFor="stripeNonWorkingDays" className="text-sm font-normal cursor-pointer">
                Stripe Non-Working Time Columns
              </Label>
            </div>
          </div>

          {/* Hide Checkbox */}
          <div className="flex items-start space-x-3">
            <Checkbox
              id="hideNonWorkingDays"
              checked={hideNonWorkingDays}
              onCheckedChange={(checked) => {
                setHideNonWorkingDays(checked as boolean);
                handleSettingChange(TIMELINE_CONG_KEYS.hideNonWorkingDays, checked as boolean);
              }}
              className="mt-0.5"
            />
            <div className="space-y-1 leading-none">
              <Label htmlFor="hideNonWorkingDays" className="text-sm font-normal cursor-pointer">
                Hide Non-Working Time Columns
              </Label>
            </div>
          </div>

          {/* Ignore Checkbox */}
          <div className="flex items-start space-x-3">
            <Checkbox
              id="skipNonWorkingDayDuringReplicating"
              checked={skipNonWorkingDayDuringReplicating}
              onCheckedChange={(checked) => {
                setSkipNonWorkingDayDuringReplicating(checked as boolean);
                handleSettingChange(TIMELINE_CONG_KEYS.skipNonWorkingDayDuringReplicating, checked as boolean);
              }}
              className="mt-0.5"
            />
            <div className="space-y-1 leading-none">
              <Label htmlFor="skipNonWorkingDayDuringReplicating" className="text-sm font-normal cursor-pointer">
                Ignore Non-Working Time Columns
              </Label>
            </div>
          </div>
        </div>


      </div>
    </Card>
  );
};
